// Angular
import { Component, OnInit } from '@angular/core';
// Models
import { Tournament } from './../../models/tournament';
// Services

import { ApiService } from './../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { Club } from './../../models/club'
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  templateUrl: './general-dashboard.component.html'
})
export class GeneralDashboardComponent implements OnInit {
  public club: any;

  constructor(private apiService: ApiService, private oAuthService: OAuthService, private fireDatabase: AngularFireDatabase, ) {
    this.club = {}
  }



  ngOnInit() {
    this.club = this.oAuthService.getClub()

    this.apiService.object("user-push/" + this.club.cid + "/disabled").then((res) => {
      console.log(res);

      this.club.disabled = res.$value ? false : true
    })

  }
  onAccountChange(event) {

    event = event ? null : true
    console.log(this.club.cid, event);

    this.apiService.set("user-push/" + this.club.cid + "/disabled", event)
  }



}




